module.exports = __webpack_public_path__ + "img/card_aires_background.595b8f5f.png";